import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { FourDotFiveDateFormatPipe } from 'src/app/core/pipes/four-dot-five-date-format.pipe';
import { FourDotFiveTimeStampFormatPipe } from 'src/app/core/pipes/four-dot-five-time-stamp-format';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { DateTimeUtilityService } from 'src/app/core/services/date-time-utility.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { JobService } from 'src/app/core/services/job.service';
import { PlanService } from 'src/app/core/services/plan.service';
import moment from 'moment';
import momentTImezone from 'moment-timezone';
import { CandidateJobMatchCard } from 'src/app/core/models/candidateJobMatchCard';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { SendAssessmentResultsModalComponent } from './send-assessment-results-modal/send-assessment-results-modal.component';
import { TIMEZONE_TO_COUNTRY } from './timezone-country-map';


interface TimezoneOption {
  name: string;
  offset: number;
  displayText: string;
  group: string;
}

@Component({
  selector: 'app-send-assessment',
  templateUrl: './send-assessment.component.html',
  styleUrls: ['./send-assessment.component.css'],
  providers: [FourDotFiveDateFormatPipe]
})
export class SendAssessmentComponent implements OnInit {

  @Input() jobMatchId!: string;
  @Input() jobMatchDetailsArrayString!: string;
  @Input() candidateId!: string;
  @Input() assessmentType!: string;
  @Input() assessmentSendMode!: string;
  @Input() notes!: string;
  @Input() corporateId!: string;
  @Input() corporateName!: string;
  @Input() buName!: string;
  @Input() isSharedRequisition!: boolean;
  @Input() sourceScreen: any;
  @Input() formalizeActivityPayload: any;
  @Output() saveCallback = new EventEmitter<any>();

  companyId!: any;
  assessmentData!: any;
  externalNotesAction: any;
  sendAssessmentLabel!: string;
  assessmentName!: string;
  candidateJobMatch: any;
  accessTimePreferences: any;
  remindAfterDays: any[] = [];
  jobMatchDetailsArray: any[] = [];
  jobMatchesThatCanBeSentAssessment: any[] = [];
  jobMatchesThatCannotBeSentAssessment: any[] = [];
  sendAssessmentLicensePreferenceEnum: any;
  assessmentDetails: any;
  previousStateDateTime: any;
  assessmentsLeft: any;
  defaultReminderInterval = 0;

  loadingFlag = true;
  savingFlag = false;
  isTrialPlanActive = false;
  isCompanyOnSoftHold = false;
  loadingAccessTimeOptionsFlag = false;
  showAccessTimeOptionsFlag = false;
  reminderErrorFlag = false;
  multipleJobMatchesFlag = false;
  loadingMultipleJobMatchesDataFlag = false;
  isStaffingCompany = false;
  isReminderEnabled = false;

  userId: any;
  copyNote: any;
  sendAssessmentForm: any;
  timeBoundStartDate: any;
  timeBoundEndDate: any;
  timeBoundStartTime: any;
  timeBoundEndTime: any;
  slotWiseStartDate: any;
  slotWiseEndDate: any;
  slotWiseStartTime: any;
  slotWiseEndTime: any;
  timezoneChoices: TimezoneOption[] = [];
  groupedTimezones: { [key: string]: TimezoneOption[] } = {};
  primaryZones = [
    'US/Hawaii',
    'America/Anchorage',
    'America/Los_Angeles',
    'America/Denver',
    'America/Chicago',
    'America/New_York'
  ];

  // Reentrancy guards for the datepicker/timepicker-sync validators - see
  // _validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound for why they're needed.
  _validatingTimeBound = false;
  _validatingSlotWiseDate = false;
  _validatingSlotWiseTime = false;

  constructor(
    private bsModalService: BsModalService,
    private authService: AuthService,
    private dateTimeUtilityService: DateTimeUtilityService,
    private jobMatchService: JobMatchService,
    private jobService: JobService,
    private assessmentService: AssessmentService,
    private planService: PlanService,
    private candidateService: CandidateService,
    private companyService: CompanyService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private fourDotFiveDateFormatPipe: FourDotFiveDateFormatPipe,
    private fourDotFiveTimeStampFormatPipe: FourDotFiveTimeStampFormatPipe
  ) { }

  // Match against zone name, offset and country so search works the way the
  // legacy chosen-based timezone-selector's grouped display implied it should.
  timezoneSearchFn(term: string, item: TimezoneOption): boolean {
    const normalizedTerm = term.toLocaleLowerCase();
    return item.displayText.toLocaleLowerCase().indexOf(normalizedTerm) > -1 ||
      item.group.toLocaleLowerCase().indexOf(normalizedTerm) > -1;
  }

  openDateOrTimePicker(inputId: string) {
    const input = $('#' + inputId) as any;
    if (input.prop('disabled')) {
      return;
    }
    if (/Time$/.test(inputId)) {
      input.timepicker('showWidget');
    } else {
      input.datepicker('show');
    }
  }

  ngOnInit(): void {
    this.initializeTimezones();
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.assessmentData = {
      jobMatchId: null,
      companyId: this.companyId,
      notes: '',
      externalNote: '',
      startDateTime: null,
      endDateTime: null,
      accessTime: null,
      reminder: 2,
      timeToComplete: null,
      timeZoneName: null
    };
    this.externalNotesAction = {};
    this.sendAssessmentLabel = '';
    this.assessmentName = '';
    this.candidateJobMatch = {};
    this.accessTimePreferences = {};
    this.remindAfterDays = [];
    this.jobMatchDetailsArray = [];
    this.jobMatchesThatCanBeSentAssessment = [];
    this.jobMatchesThatCannotBeSentAssessment = [];
    this.sendAssessmentLicensePreferenceEnum = null;
    this.assessmentDetails = null;
    this.previousStateDateTime = null;
    this.assessmentsLeft;
    this.defaultReminderInterval = 0;
    //flags
    this.loadingFlag = true;
    this.savingFlag = false;
    this.isTrialPlanActive = false;
    this.isCompanyOnSoftHold = false;
    this.loadingAccessTimeOptionsFlag = false;
    this.showAccessTimeOptionsFlag = false;
    this.reminderErrorFlag = false;
    this.multipleJobMatchesFlag = false;
    this.loadingMultipleJobMatchesDataFlag = false;
    this.isStaffingCompany = false;
    this.isReminderEnabled = false;

    this.isStaffingCompany = this.companyService.isStaffingCompany();
    this.getCompanyState(() => {
      this.getCompanyPlanDetails(() => {
        this._initializeAssessmentDetails();
        console.log('assessmentData.timeZoneName=', this.assessmentData && this.assessmentData.timeZoneName);
      });
    });
  }

  // Browser timezone detection (both jstz and moment.tz.guess()/Intl) can return a legacy
  // IANA alias (e.g. "Asia/Calcutta") depending on the OS/browser's tzdata version, which
  // isn't in TIMEZONE_TO_COUNTRY and so wouldn't be grouped/selected correctly. Resolve it
  // to its modern canonical name (e.g. "Asia/Kolkata") using moment-timezone's own link
  // table whenever the detected name isn't already one we recognize.
  _toCanonicalZoneName(zoneName: string): string {
    if (!zoneName || TIMEZONE_TO_COUNTRY[zoneName]) {
      return zoneName;
    }
    const links = (momentTImezone as any).tz._links;
    const names = (momentTImezone as any).tz._names;
    const key = zoneName.toLowerCase().replace(/\//g, '_');
    const linkedKey = links && links[key];
    const linkedName = linkedKey && names && names[linkedKey];
    return (linkedName && TIMEZONE_TO_COUNTRY[linkedName]) ? linkedName : zoneName;
  }

  initializeTimezones() {
    this.timezoneChoices = (momentTImezone as any).tz.names().map(zone => {
      const zoneMoment = (momentTImezone as any).tz(zone);
      // moment's utcOffset() returns minutes ahead of UTC (positive east of UTC),
      // unlike Zone#utcOffset() which is sign-flipped (positive west of UTC) - use
      // the moment instance consistently for both sorting and display.
      const offset = zoneMoment.utcOffset();
      // Group by country, same as the legacy AngularJS timezone-selector directive
      // (angular-timezone-selector-fixed), which maps each IANA zone to a country
      // via the same zone.csv/cca2_to_country_name.csv data baked into timezone-country-map.ts.
      const country = TIMEZONE_TO_COUNTRY[zone] || 'Other';
      return {
        name: zone,
        offset: offset,
        displayText: `${zone.replace(/_/g, ' ')} (UTC${zoneMoment.format('Z')})`,
        group: `${country}:`
      };
    });
    this.timezoneChoices.sort((a, b) => a.offset - b.offset);
    this.groupedTimezones = {};
    this.timezoneChoices.forEach(zone => {
      if (!this.groupedTimezones[zone.group]) {
        this.groupedTimezones[zone.group] = [];
      }
      this.groupedTimezones[zone.group].push(zone);
    });
  }

  _initializeAssessmentDetails() {
    this.userId = this.authService.getUserDetails().id;
    if (!_.isUndefined(this.jobMatchDetailsArrayString)) {
      this.multipleJobMatchesFlag = true;
      this.jobMatchDetailsArray = JSON.parse(this.jobMatchDetailsArrayString);
      this.jobMatchId = this.jobMatchDetailsArray[0].jobMatchId;
      this.candidateId = this.jobMatchDetailsArray[0].candidateId;
    } else {
      this.multipleJobMatchesFlag = false;
      let tempObject: any = {};
      tempObject.jobMatchId = this.jobMatchId;
      tempObject.candidateId = this.candidateId;
      this.jobMatchDetailsArray.push(tempObject);
    }

    if (this.multipleJobMatchesFlag) {
      this.loadingMultipleJobMatchesDataFlag = true;
      // initialize for each of the job matches
      angular.forEach(this.jobMatchDetailsArray, (val, key) => {
        val.loadingFlag = true;
        val.sendErrorType = null;
        val.sendErrorMessage = null;
        val.jobMatchData = {};
      });
      // get details for each of the job matches to be shown
      angular.forEach(this.jobMatchDetailsArray, (val, key) => {
        this.getCandidateJobMatchCardInfo(val.jobMatchId, () => {
          val.jobMatchData = angular.copy(this.candidateJobMatch);
          val.loadingFlag = false;
          if (this.assessmentType == "Technical" && (val.jobMatchData.jobMatchCurrentState == 'In Tech Assessment' || val.jobMatchData.jobMatchCurrentState == 'Tech Assessment Canceled')) {
            let sendActionInfo: any = _.find(val.jobMatchData.availableActions, { actionType: "SEND_TECHNICAL_ASSESSMENT" });
            if (sendActionInfo == undefined) {
              val.sendErrorType = 'actionNotAllowed';
              let message = "";
              message = val.jobMatchData.joinedInOtherJob ? 'Candidate is already in joined status in another requisition.' : (val.jobMatchData.filledInOtherJob ? 'Candidate is already in filled status in another requisition.' : '');
              val.sendErrorMessage = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "') - " + message;
              this.jobMatchesThatCannotBeSentAssessment.push(val);
            } else if (sendActionInfo.allowed) {
              val.message = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "')";
              this.jobMatchesThatCanBeSentAssessment.push(val);
            } else {
              val.sendErrorType = 'actionNotAllowed';
              val.sendErrorMessage = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "') - " + sendActionInfo.message;
              this.jobMatchesThatCannotBeSentAssessment.push(val);
            }
          } else if (this.assessmentType == "Technical" && _.find(val.jobMatchData.availableActions, { actionType: "RE_SEND_TECHNICAL_ASSESSMENT" }) !== undefined) {
            let resendActionInfo: any = _.find(val.jobMatchData.availableActions, { actionType: "RE_SEND_TECHNICAL_ASSESSMENT" });
            if (resendActionInfo.allowed) {
              this._setResendAssessmentInfo(val);
              this.jobMatchesThatCanBeSentAssessment.push(val);
            } else {
              val.sendErrorType = 'actionNotAllowed';
              val.sendErrorMessage = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "') - " + resendActionInfo.message;
              this.jobMatchesThatCannotBeSentAssessment.push(val);
            }
          } else if (this.assessmentType == "Value" && (val.jobMatchData.jobMatchCurrentState == 'In Value Assessment' || val.jobMatchData.jobMatchCurrentState == 'Value Assessment Canceled')) {
            let sendActionInfo: any = _.find(val.jobMatchData.availableActions, { actionType: "SEND_VALUE_ASSESSMENT" });
            if (sendActionInfo == undefined) {
              val.sendErrorType = 'actionNotAllowed';
              let message = "";
              message = val.jobMatchData.joinedInOtherJob ? 'Candidate is already in joined status in another requisition' : (val.jobMatchData.filledInOtherJob ? 'Candidate is already in filled status in another requisition.' : '');
              val.sendErrorMessage = " (Current status: '" + message + "')";
              this.jobMatchesThatCannotBeSentAssessment.push(val);
            } else if (sendActionInfo.allowed) {
              val.message = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "')";
              this.jobMatchesThatCanBeSentAssessment.push(val);
            } else {
              val.sendErrorType = 'actionNotAllowed';
              val.sendErrorMessage = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "') - " + sendActionInfo.message;
              this.jobMatchesThatCannotBeSentAssessment.push(val);
            }
          } else if (this.assessmentType == "Value" && _.find(val.jobMatchData.availableActions, { actionType: "RE_SEND_VALUE_ASSESSMENT" }) !== undefined) {
            let resendActionInfo: any = _.find(val.jobMatchData.availableActions, { actionType: "RE_SEND_VALUE_ASSESSMENT" });
            if (resendActionInfo.allowed) {
              this._setResendAssessmentInfo(val);
              this.jobMatchesThatCanBeSentAssessment.push(val);
            } else {
              val.sendErrorType = 'actionNotAllowed';
              val.sendErrorMessage = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "') - " + resendActionInfo.message;
              this.jobMatchesThatCannotBeSentAssessment.push(val);
            }
          } else {
            val.sendErrorType = 'wrongState';
            val.sendErrorMessage = " is not in a valid status (Current status: '" + val.jobMatchData.jobMatchCurrentState + "').";
            this.jobMatchesThatCannotBeSentAssessment.push(val);
          }
          if ((this.jobMatchesThatCanBeSentAssessment.length + this.jobMatchesThatCannotBeSentAssessment.length) == this.jobMatchDetailsArray.length) {
            this.loadingMultipleJobMatchesDataFlag = false;
          }
          if (!this.loadingMultipleJobMatchesDataFlag && !this.loadingAccessTimeOptionsFlag) {
            this.loadingFlag = false;
          }
        }, (error) => {
          val.loadingFlag = false;
          this.loadingMultipleJobMatchesDataFlag = false;
        });
      });
    }

    this.assessmentData.jobMatchId = this.jobMatchId;
    // matches the legacy timezone-selector directive's set-local="true" behavior: use
    // jstz (globally bundled, see angular.json scripts) as the primary detection method,
    // falling back to moment-timezone's own guess. Either can return a legacy IANA alias
    // (e.g. "Asia/Calcutta" instead of "Asia/Kolkata") depending on the OS/browser's
    // tzdata version, so resolve it to the canonical name our dropdown/grouping uses.
    const jstzGlobal = (window as any).jstz;
    const detectedZoneName = jstzGlobal ? jstzGlobal.determine().name() : this.dateTimeUtilityService.guessBrowserTimeZoneName();
    this.assessmentData.timeZoneName = this._toCanonicalZoneName(detectedZoneName);
    this.loadingAccessTimeOptionsFlag = true;
    for (let i = 0; i <= 31; i++) {
      this.remindAfterDays.push({
        id: i,
        text: '' + i
      });
    }
    if (_.isNull(this.assessmentSendMode)) {
      this.assessmentSendMode = 'send';
    }
    switch (this.assessmentType) {
      case 'Technical':
        this.sendAssessmentLabel = 'Technical Assessment';
        this.sendAssessmentLicensePreferenceEnum = 'TECH_ASSESSMENT';
        break;
      case 'Value':
        this.sendAssessmentLabel = 'Value Assessment';
        this.sendAssessmentLicensePreferenceEnum = 'VALUE_ASSESSMENT';
        break;
    }
    this.assessmentData.notes = 'Sending ' + this.sendAssessmentLabel;
    if (this.assessmentSendMode == 'resend') {
      this.assessmentData.notes = 'Resending ' + this.sendAssessmentLabel;
    }
    if (this.notes !== "") {
      this.assessmentData.notes = this.notes;
    }
    this.candidateJobMatch = new CandidateJobMatchCard();
    this.getCandidateJobMatchCardInfo(this.jobMatchId, () => {
      if (this.isTrialPlanActive || this.isCompanyOnSoftHold) {
        this.getAvailableAssessments();
      }
      if (this.assessmentSendMode == 'resend') {
        let assessmentDetailsObject: any = {};
        assessmentDetailsObject.jobMatchId = this.jobMatchId;
        assessmentDetailsObject.assessmentType = this.assessmentType;
        this.assessmentService.getCandidateAssessmentDetails(assessmentDetailsObject, (data) => {
          this.assessmentDetails = data;
          this.assessmentDetails.isSendAssessmentFailed = this.candidateJobMatch.jobMatchCurrentState.includes("Failed");

          if (!_.isNull(this.assessmentDetails.expiredDateTime)) {
            this.assessmentDetails.expiredDateTime = new Date(this.assessmentDetails.expiredDateTime);
          }
          if (!_.isNull(this.assessmentDetails.cancelledDateTime)) {
            this.assessmentDetails.cancelledDateTime = new Date(this.assessmentDetails.cancelledDateTime);
          }
          if (!_.isNull(this.assessmentDetails.completedDateTime)) {
            this.assessmentDetails.completedDateTime = new Date(this.assessmentDetails.completedDateTime);
          }
          if (!_.isNull(this.assessmentDetails.sentDateTime)) {
            this.assessmentDetails.sentDateTime = new Date(this.assessmentDetails.sentDateTime);
          }
          if (!_.isNull(this.assessmentDetails.suspendedDateTime)) {
            this.assessmentDetails.suspendedDateTime = new Date(this.assessmentDetails.suspendedDateTime);
          }
          if (!_.isNull(this.assessmentDetails.terminatedDateTime)) {
            this.assessmentDetails.terminatedDateTime = new Date(this.assessmentDetails.terminatedDateTime);
          }
          if (!_.isNull(this.assessmentDetails.testLeftDateTime)) {
            this.assessmentDetails.testLeftDateTime = new Date(this.assessmentDetails.testLeftDateTime);
          }
          if (this.assessmentDetails.assessmentLinkStatus == 'Expired' && !_.isNull(this.assessmentDetails.expiredDateTime)) {
            this.previousStateDateTime = this.assessmentDetails.expiredDateTime;
          } else if (this.assessmentDetails.assessmentLinkStatus == 'Suspended' && !_.isNull(this.assessmentDetails.suspendedDateTime)) {
            this.previousStateDateTime = this.assessmentDetails.suspendedDateTime;
          } else if (this.assessmentDetails.assessmentLinkStatus == 'Terminated' && !_.isNull(this.assessmentDetails.terminatedDateTime)) {
            this.previousStateDateTime = this.assessmentDetails.terminatedDateTime;
          } else if (this.assessmentDetails.assessmentLinkStatus == 'Test Left' && !_.isNull(this.assessmentDetails.testLeftDateTime)) {
            this.previousStateDateTime = this.assessmentDetails.testLeftDateTime;
          } else if (this.assessmentDetails.assessmentLinkStatus == 'Complete' && !_.isNull(this.assessmentDetails.completedDateTime)) {
            this.previousStateDateTime = this.assessmentDetails.completedDateTime;
          } else if (this.assessmentDetails.isSendAssessmentFailed && !_.isNull(this.assessmentDetails.sentDateTime)) {
            this.previousStateDateTime = this.assessmentDetails.sentDateTime;
          } else {
            this.previousStateDateTime = '';
          }
          this.assessmentDetails.sendAssessmentsCount = this.assessmentDetails.sendAssessmentsCount + 1;
          this.assessmentDetails = this._setSentAssessmentsPostfix(this.assessmentDetails);
        }, (error) => {
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
      }
      this.getAccessTimePreferences(() => {
        if (_.isNull(this.accessTimePreferences.timeToComplete)) {
          // default time to complete, if it is null
          this.accessTimePreferences.timeToComplete = 2;
        }
        if (_.isNull(this.accessTimePreferences.reminderInterval)) {
          // default reminder interval, if it is null
          this.accessTimePreferences.reminderInterval = 2;
        }
        this.assessmentData.reminder = this.accessTimePreferences.reminderInterval;
        this.defaultReminderInterval = this.assessmentData.reminder;
        if (this.assessmentData.reminder > 0) {
          this.isReminderEnabled = true;
        } else {
          this.defaultReminderInterval = 2;
        }
        // initialize all access time options to be false
        this.accessTimePreferences.anyTime = false;
        this.accessTimePreferences.timeBound = false;
        this.accessTimePreferences.slotWise = false;
        // TODO: remove jQuery and use data binding to set the default value.
        $('#reminderInDays').val(this.assessmentData.reminder);
        let accessTimeOptionsToShowCount = 0;
        angular.forEach(this.accessTimePreferences.accessTimeDtos, (val, key) => {
          if (val.accessTimeLabel == 'Any Time') {
            if (val.accessTimeEnabled && val.accessTimeValue) {
              this.accessTimePreferences.anyTime = true;
              accessTimeOptionsToShowCount++;
            }
          } else if (val.accessTimeLabel == 'Time Bound') {
            if (val.accessTimeEnabled && val.accessTimeValue) {
              this.accessTimePreferences.timeBound = true;
              accessTimeOptionsToShowCount++;
            }
          } else if (val.accessTimeLabel == 'Slot Wise') {
            if (val.accessTimeEnabled && val.accessTimeValue) {
              this.accessTimePreferences.slotWise = true;
              accessTimeOptionsToShowCount++;
            }
          }
        });
        if (accessTimeOptionsToShowCount == 0) {
          this.showAccessTimeOptionsFlag = false;
          // default to any time if all the options are sent as 'false'
          this.assessmentData.accessTime = 'anyTime';
        } else if (accessTimeOptionsToShowCount == 1) {
          this.showAccessTimeOptionsFlag = false;
          if (this.accessTimePreferences.anyTime) {
            this.assessmentData.accessTime = 'anyTime';
          } else if (this.accessTimePreferences.timeBound) {
            this.assessmentData.accessTime = 'timeBound';
            this._initializeDateAndTimePickersForTimeBound();
          } else if (this.accessTimePreferences.slotWise) {
            this.assessmentData.accessTime = 'slotWise';
            this._initializeDateAndTimePickersForSlotWise();
          }
        } else if (accessTimeOptionsToShowCount > 1) {
          this.showAccessTimeOptionsFlag = true;
          if (this.accessTimePreferences.anyTime) {
            this.assessmentData.accessTime = 'anyTime';
          }
          if (this.accessTimePreferences.timeBound) {
            this._initializeDateAndTimePickersForTimeBound();
          }
          if (this.accessTimePreferences.slotWise) {
            this._initializeDateAndTimePickersForSlotWise();
          }
          // default to the first available option
          if (this.accessTimePreferences.anyTime) {
            this.assessmentData.accessTime = 'anyTime';
          } else {
            // time bound should be available since anyTime is not available
            this.assessmentData.accessTime = 'timeBound';
          }
        }
        this.loadingAccessTimeOptionsFlag = false;
        if (!this.loadingAccessTimeOptionsFlag && !this.loadingMultipleJobMatchesDataFlag) {
          this.loadingFlag = false;
        }
        setTimeout(() => {
          this.reminderChanged();
        }, 500);
      });
    });
  }

  _setResendAssessmentInfo(jobMatch) {
    let assessmentDetailsObject: any = {};
    assessmentDetailsObject.jobMatchId = jobMatch.jobMatchId;
    assessmentDetailsObject.assessmentType = this.assessmentType;
    this.assessmentService.getCandidateAssessmentDetails(assessmentDetailsObject, (data) => {
      jobMatch.assessmentDetails = data;

      if (!_.isNull(jobMatch.assessmentDetails.expiredDateTime)) {
        jobMatch.assessmentDetails.expiredDateTime = new Date(jobMatch.assessmentDetails.expiredDateTime);
      }
      if (!_.isNull(jobMatch.assessmentDetails.cancelledDateTime)) {
        jobMatch.assessmentDetails.cancelledDateTime = new Date(jobMatch.assessmentDetails.cancelledDateTime);
      }
      if (!_.isNull(jobMatch.assessmentDetails.completedDateTime)) {
        jobMatch.assessmentDetails.completedDateTime = new Date(jobMatch.assessmentDetails.completedDateTime);
      }
      if (!_.isNull(jobMatch.assessmentDetails.sentDateTime)) {
        jobMatch.assessmentDetails.sentDateTime = new Date(jobMatch.assessmentDetails.sentDateTime);
      }
      if (!_.isNull(jobMatch.assessmentDetails.suspendedDateTime)) {
        jobMatch.assessmentDetails.suspendedDateTime = new Date(jobMatch.assessmentDetails.suspendedDateTime);
      }
      if (!_.isNull(jobMatch.assessmentDetails.terminatedDateTime)) {
        jobMatch.assessmentDetails.terminatedDateTime = new Date(jobMatch.assessmentDetails.terminatedDateTime);
      }
      if (!_.isNull(jobMatch.assessmentDetails.testLeftDateTime)) {
        jobMatch.assessmentDetails.testLeftDateTime = new Date(jobMatch.assessmentDetails.testLeftDateTime);
      }
      if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Expired' && !_.isNull(jobMatch.assessmentDetails.expiredDateTime)) {
        jobMatch.previousStateDateTime = jobMatch.assessmentDetails.expiredDateTime;
      } else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Suspended' && !_.isNull(jobMatch.assessmentDetails.suspendedDateTime)) {
        jobMatch.previousStateDateTime = jobMatch.assessmentDetails.suspendedDateTime;
      } else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Terminated' && !_.isNull(jobMatch.assessmentDetails.terminatedDateTime)) {
        jobMatch.previousStateDateTime = jobMatch.assessmentDetails.terminatedDateTime;
      } else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Test Left' && !_.isNull(jobMatch.assessmentDetails.testLeftDateTime)) {
        jobMatch.previousStateDateTime = jobMatch.assessmentDetails.testLeftDateTime;
      } else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Complete' && !_.isNull(jobMatch.assessmentDetails.completedDateTime)) {
        jobMatch.previousStateDateTime = jobMatch.assessmentDetails.completedDateTime;
      } else if (jobMatch.jobMatchData.jobMatchCurrentState.includes('Failed') && !_.isNull(jobMatch.assessmentDetails.sentDateTime)) {
        jobMatch.previousStateDateTime = jobMatch.assessmentDetails.sentDateTime;
      } else {
        jobMatch.previousStateDateTime = '';
      }
      jobMatch.assessmentDetails.sendAssessmentsCount = jobMatch.assessmentDetails.sendAssessmentsCount + 1;
      jobMatch.assessmentDetails = this._setSentAssessmentsPostfix(jobMatch.assessmentDetails);
      jobMatch.message = "";
      let htmlMessage = "Resending Assessment ";
      if (jobMatch.assessmentDetails.assessmentLinkStatus == "Cancelled") {
        htmlMessage = htmlMessage + "as it was previously Canceled on '" + this.fourDotFiveTimeStampFormatPipe.transform(jobMatch.assessmentDetails.cancelledDateTime) + "'";
      } else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Expired' || jobMatch.assessmentDetails.assessmentLinkStatus == 'Suspended' || jobMatch.assessmentDetails.assessmentLinkStatus == 'Test Left' || jobMatch.assessmentDetails.assessmentLinkStatus == 'Terminated') {
        htmlMessage = htmlMessage + "as it is in " + jobMatch.assessmentDetails.assessmentLinkStatus + " status. The Assessment was sent on '" + this.fourDotFiveTimeStampFormatPipe.transform(jobMatch.assessmentDetails.sentDateTime) + "' and  '" + jobMatch.assessmentDetails.assessmentLinkStatus + "' on '" + this.fourDotFiveTimeStampFormatPipe.transform(jobMatch.previousStateDateTime) + "'";
      } else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Complete') {
        htmlMessage = htmlMessage + " as it was previously Completed. The Assessment was sent on '" + this.fourDotFiveTimeStampFormatPipe.transform(jobMatch.assessmentDetails.sentDateTime) + "' and was Completed on '" + this.fourDotFiveTimeStampFormatPipe.transform(jobMatch.previousStateDateTime) + "'";

      } else if (jobMatch.assessmentDetails.isSendAssessmentFailed) {
        htmlMessage = htmlMessage + "as the previous attempt to send failed on '" + this.fourDotFiveTimeStampFormatPipe.transform(jobMatch.assessmentDetails.sentDateTime) + "'";
      }
      jobMatch.message = jobMatch.message + htmlMessage;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _setSentAssessmentsPostfix(assessmentDetails) {
    assessmentDetails.sendAssessmentsCountDisplayValue = "";
    if (assessmentDetails.sendAssessmentsCount == 1) {
      assessmentDetails.sendAssessmentsCountDisplayValue = "1st";
    } else if (assessmentDetails.sendAssessmentsCount == 2) {
      assessmentDetails.sendAssessmentsCountDisplayValue = "2nd";
    } else if (assessmentDetails.sendAssessmentsCount == 3) {
      assessmentDetails.sendAssessmentsCountDisplayValue = "3rd";
    } else {
      assessmentDetails.sendAssessmentsCountDisplayValue = assessmentDetails.sendAssessmentsCount + "th";
    }
    return assessmentDetails;
  }

  getCompanyState(successCallback) {
    if (this.isStaffingCompany && this.isSharedRequisition && this.corporateId) {
      this.companyService.getCompanyDetails(this.corporateId, (data) => {
        this.isCompanyOnSoftHold = data.companyState == 'SoftHold' ? true : false;
        successCallback();
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        successCallback();
      });
    } else {
      this.isCompanyOnSoftHold = this.authService.getUserDetails().company.companyState == 'SoftHold' ? true : false;
      successCallback();
    }
  }

  getCompanyPlanDetails(successCallback) {
    let getPlanOfCompanyId = this.companyId;
    if (this.isStaffingCompany && this.isSharedRequisition && this.corporateId) {
      getPlanOfCompanyId = this.corporateId;
    }
    if (!getPlanOfCompanyId) {
      console.log('No company id found');
      successCallback();
      return;
    }
    this.planService.getCompanyPlanDetails(getPlanOfCompanyId, (data) => {
      if (!_.isNull(data)) {
        this.isTrialPlanActive = data.plan == "Trial" ? true : false;
      }
      successCallback();
    }, (error) => {
      console.log('getCompanyPlanDetails error', error);
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      successCallback();
    });
  }

  getAvailableAssessments() {
    this.planService.getAvailableTechAssessmentsCount(this.companyId, this.candidateJobMatch.jobMatchJobId, (data) => {
      this.assessmentsLeft = data["techAssessmentsLeft"];
    },
      (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      }
    );
  }

  sendAssessment(sendAssessmentForm: any) {
    this.sendAssessmentForm = sendAssessmentForm;
    if (!this.sendAssessmentForm.invalid && !this.reminderErrorFlag) {
      this.savingFlag = true;
      let assessmentDataForSave: any = angular.copy(this.assessmentData);
      if (this.assessmentData.accessTime == 'anyTime') {
        assessmentDataForSave.startDateTime = null;
        assessmentDataForSave.endDateTime = null;
      } else if (this.assessmentData.accessTime == 'timeBound') {
        assessmentDataForSave.startDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.timeBoundStartDate + ' ' + this.timeBoundStartTime));
        assessmentDataForSave.endDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.timeBoundEndDate + ' ' + this.timeBoundEndTime));
      } else if (this.assessmentData.accessTime == 'slotWise') {
        assessmentDataForSave.startDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.slotWiseStartDate + ' ' + this.slotWiseStartTime));
        assessmentDataForSave.endDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.slotWiseEndDate + ' ' + this.slotWiseEndTime));
      }
      assessmentDataForSave.sentDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date());
      if (this.assessmentSendMode == 'send') {
        if (this.multipleJobMatchesFlag) {
          assessmentDataForSave.jobMatchIds = this.jobMatchesThatCanBeSentAssessment.map((jobMatch) => {
            return jobMatch.jobMatchId;
          });
          delete assessmentDataForSave.jobMatchId;
          this.candidateService.sendAssessments(this.assessmentType, assessmentDataForSave, (sendResultsArray) => {
          this.savingFlag = false;
            const config = new ModalConfig();
            config.class = 'four-dot-five-modal-medium';
            config.ignoreBackdropClick = true;
            config.keyboard = false;
            config.initialState = {
              jobMatchDetailsArray: this.jobMatchesThatCanBeSentAssessment,
              sendResultsArray: sendResultsArray
            };
            const sendAssessmentResultsModal = this.bsModalService.show(SendAssessmentResultsModalComponent, config);

            sendAssessmentResultsModal.content.onClose.subscribe(callbackObject => {
              if (callbackObject && callbackObject.callbackType == 'close' && this.saveCallback) {
                this.saveCallback.emit();
              }
            });

          }, (error) => {
            this.savingFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
          });
        } else {
          this.jobMatchService.sendAssessment(this.assessmentType, assessmentDataForSave, (data) => {
            this.savingFlag = false;
            if (this.saveCallback) {
              this.saveCallback.emit();
            }
          }, (error) => {
            this.savingFlag = false;
            if (this.authService.isOnline) {
              this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
          });
        }
      } else {
        assessmentDataForSave.testType = this.assessmentType;
        this.jobMatchService.resendAssessment(assessmentDataForSave, (data) => {
          this.savingFlag = false;
          if (this.saveCallback) {
            this.saveCallback.emit();
          }
        }, (error) => {
          this.savingFlag = false;
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
      }
    }
  }

  getCandidateJobMatchCardInfo(jobMatchId: any, successCallback?: any, errorCallback?: any) {
    this.jobMatchService.getCandidateJobMatchCard(jobMatchId, this.companyId, (data) => {
      angular.merge(this.candidateJobMatch, data);
      this.candidateJobMatch = this._massageCandidateJobMatchData(this.candidateJobMatch);
      if (successCallback) {
        successCallback();
      }
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    }, undefined);
    if (errorCallback) {
      errorCallback(Error);
    }
  }

  _massageCandidateJobMatchData(candidateJobMatch) {
    candidateJobMatch.name = candidateJobMatch.firstName + ' ' + candidateJobMatch.lastName;
    if (candidateJobMatch.jobMatchRequisitionNum == null) {
      candidateJobMatch.jobMatchRequisitionNum = '-';
    }
    this.assessmentName = this.assessmentType == 'Technical' ? candidateJobMatch.techAssessmentName : candidateJobMatch.valueAssessmentName;
    return candidateJobMatch;
  }

  getAccessTimePreferences(successCallback) {
    this.jobService.getAssessmentAccessTime(this.candidateJobMatch.jobMatchJobId, this.sendAssessmentLicensePreferenceEnum, (data) => {
      this.accessTimePreferences = data;
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  accessTimeTypeChanged() {
    console.log('Selected Access Time:', this.assessmentData.accessTime);
    setTimeout(() => {
      if (this.assessmentData.accessTime === 'timeBound') {
        console.log('Initializing TimeBound');
        this._initializeDateAndTimePickersForTimeBound();
      } else if (this.assessmentData.accessTime === 'slotWise') {
        console.log('Initializing SlotWise');
        this._initializeDateAndTimePickersForSlotWise();
      }
    }, 0);
  }

  reminderChanged() {
    if (this.isReminderEnabled && this.assessmentData.reminder == 0) {
      this.assessmentData.reminder = 1;
    }
    if (this.assessmentData.accessTime == 'timeBound' || this.assessmentData.accessTime == 'slotWise') {
      let currentStartDateTime;
      let momentOfCurrentStartDateTime;
      let currentEndDateTime;
      let momentOfCurrentEndDateTime

      if (this.assessmentData.accessTime == 'timeBound') {
        currentStartDateTime = new Date(this.timeBoundStartDate + ' ' + this.timeBoundStartTime);
        momentOfCurrentStartDateTime = moment(currentStartDateTime);
        currentEndDateTime = new Date(this.timeBoundEndDate + ' ' + this.timeBoundEndTime);
        momentOfCurrentEndDateTime = moment(currentEndDateTime);
      } else {
        momentOfCurrentStartDateTime = moment(new Date(this.slotWiseStartDate));
        momentOfCurrentEndDateTime = moment(new Date(this.slotWiseEndDate));
      }
      let differenceInDays = momentOfCurrentEndDateTime.diff(momentOfCurrentStartDateTime, 'days', true);
      if (this.assessmentData.reminder >= differenceInDays && this.isReminderEnabled) {
        this.reminderErrorFlag = true;
      } else {
        this.reminderErrorFlag = false;
      }
    }
  }

  timeZoneChanged() {
    if (this.assessmentData.accessTime == 'timeBound') {
      let currentDateTimeStringInSelectedTimeZone = momentTImezone().tz(this.assessmentData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
      let currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
      let momentOfCurrentDate = moment(currentDate);
      let remainderWithClosestQuarter = momentOfCurrentDate.minute() % 15;
      let momentOfCurrentDateTimeFlooredToClosetQuarter = moment(momentOfCurrentDate).subtract(remainderWithClosestQuarter, 'm');
      let momentOfDefaultEndDateTime = moment(momentOfCurrentDateTimeFlooredToClosetQuarter).add(this.accessTimePreferences.timeToComplete, 'd');

      ($("#timeBoundStartDate") as any).datepicker("setDate", momentOfCurrentDateTimeFlooredToClosetQuarter.toDate());
      ($("#timeBoundStartDate") as any).datepicker("setStartDate", momentOfCurrentDateTimeFlooredToClosetQuarter.toDate());
      ($("#timeBoundStartDate") as any).datepicker("update", this.fourDotFiveDateFormatPipe.transform(momentOfCurrentDateTimeFlooredToClosetQuarter.toDate()));
      // datepicker's programmatic "setDate" doesn't fire the 'changeDate' event our
      // ngModel-sync listener relies on - set the model explicitly here too.
      this.timeBoundStartDate = ($("#timeBoundStartDate") as any).val();

      ($("#timeBoundEndDate") as any).datepicker("setDate", momentOfDefaultEndDateTime.toDate());
      // allowed start date on the calendar of end date should still be the same as start date.
      ($("#timeBoundEndDate") as any).datepicker("setStartDate", momentOfCurrentDateTimeFlooredToClosetQuarter.toDate());
      ($("#timeBoundEndDate") as any).datepicker("update", this.fourDotFiveDateFormatPipe.transform(momentOfDefaultEndDateTime.toDate()));
      this.timeBoundEndDate = ($("#timeBoundEndDate") as any).val();

      ($("#timeBoundStartTime") as any).timepicker("setTime", this._getTimeStringInAMPMFormat(momentOfCurrentDateTimeFlooredToClosetQuarter.toDate()));
      ($('#timeBoundEndTime') as any).timepicker("setTime", "11:59 PM");
      // trigger a reminder change to check if remind after days is in bound
      this.reminderChanged();
    } else if (this.assessmentData.accessTime == 'slotWise') {
      let currentDateTimeStringInSelectedTimeZone = momentTImezone().tz(this.assessmentData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
      let currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
      let momentOfDefaultEndDateTime = moment(currentDate).add(this.accessTimePreferences.timeToComplete, 'd');

      ($("#slotWiseStartDate") as any).datepicker("setDate", currentDate);
      ($("#slotWiseStartDate") as any).datepicker("setStartDate", currentDate);
      ($("#slotWiseStartDate") as any).datepicker("update", this.fourDotFiveDateFormatPipe.transform(currentDate));
      // datepicker's programmatic "setDate" doesn't fire the 'changeDate' event our
      // ngModel-sync listener relies on - set the model explicitly here too.
      this.slotWiseStartDate = ($("#slotWiseStartDate") as any).val();

      ($("#slotWiseEndDate") as any).datepicker("setDate", momentOfDefaultEndDateTime.toDate());
      // allowed start date on the calendar of end date should still be the same as start date.
      ($("#slotWiseEndDate") as any).datepicker("setStartDate", currentDate);
      ($("#slotWiseEndDate") as any).datepicker("update", this.fourDotFiveDateFormatPipe.transform(momentOfDefaultEndDateTime.toDate()));
      this.slotWiseEndDate = ($("#slotWiseEndDate") as any).val();

      ($("#slotWiseStartTime") as any).timepicker("setTime", "09:00 AM");
      ($('#slotWiseEndTime') as any).timepicker("setTime", "12:00 PM");
      // trigger a reminder change to check if remind after days is in bound
      this.reminderChanged();
    }
  }

  _initializeDateAndTimePickersForTimeBound() {
    $(document).ready(() => {
      let currentDateTimeStringInSelectedTimeZone = momentTImezone().tz(this.assessmentData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
      let currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
      let momentOfCurrentDate = moment(currentDate);
      let remainderWithClosestQuarter = momentOfCurrentDate.minute() % 15;
      let momentOfCurrentDateTimeFlooredToClosetQuarter = moment(momentOfCurrentDate).subtract(remainderWithClosestQuarter, 'm');
      let momentOfDefaultEndDateTime = moment(momentOfCurrentDateTimeFlooredToClosetQuarter).add(this.accessTimePreferences.timeToComplete, 'd');

      ($('#timeBoundStartDate') as any).datepicker({
        format: "M d, yyyy",
        startDate: momentOfCurrentDateTimeFlooredToClosetQuarter.toDate(),
        weekStart: 1,
        autoclose: true
      });
      // set current date as default value
      ($("#timeBoundStartDate") as any).datepicker("setDate", momentOfCurrentDateTimeFlooredToClosetQuarter.toDate());
      ($("#timeBoundStartDate") as any).datepicker("update", this.fourDotFiveDateFormatPipe.transform(momentOfCurrentDateTimeFlooredToClosetQuarter.toDate()));
      // these widgets sync via a native 'change' event, which Angular's ngModel does
      // not listen for on text inputs - set the model explicitly for the initial value too.
      this.timeBoundStartDate = ($("#timeBoundStartDate") as any).val();

      ($('#timeBoundEndDate') as any).datepicker({
        format: "M d, yyyy",
        startDate: momentOfCurrentDateTimeFlooredToClosetQuarter.toDate(),
        weekStart: 1,
        autoclose: true
      });

      ($("#timeBoundEndDate") as any).datepicker("setDate", momentOfDefaultEndDateTime.toDate());
      ($("#timeBoundEndDate") as any).datepicker("update", this.fourDotFiveDateFormatPipe.transform(momentOfDefaultEndDateTime.toDate()));
      this.timeBoundEndDate = ($("#timeBoundEndDate") as any).val();

      ($('#timeBoundStartTime') as any).timepicker({
        minuteStep: 5,
        showSeconds: false,
        showMeridian: true,
        disableFocus: true,
        defaultTime: this._getTimeStringInAMPMFormat(momentOfCurrentDateTimeFlooredToClosetQuarter.toDate())
      });
      this.timeBoundStartTime = this._getTimeStringInAMPMFormat(momentOfCurrentDateTimeFlooredToClosetQuarter.toDate());

      ($('#timeBoundEndTime') as any).timepicker({
        minuteStep: 5,
        showSeconds: false,
        showMeridian: true,
        disableFocus: true,
        defaultTime: '11:59 PM'
      });
      this.timeBoundEndTime = '11:59 PM';

      ($('#timeBoundStartDate') as any).datepicker().on('changeDate', (e) => {
        // bootstrap-datepicker syncs via a native 'change' event, which Angular's
        // ngModel does not listen for on text inputs (only 'input') - read the
        // picker's value directly so the model isn't left stale.
        this.timeBoundStartDate = ($('#timeBoundStartDate') as any).val();
        this._validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound();
        setTimeout(() => {
          // trigger a reminder change to check if remind after days is in bound
          this.reminderChanged();
        }, 100);
      });

      ($('#timeBoundEndDate') as any).datepicker().on('changeDate', (e) => {
        this.timeBoundEndDate = ($('#timeBoundEndDate') as any).val();
        this._validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound();
        setTimeout(() => {
          // trigger a reminder change to check if remind after days is in bound
          this.reminderChanged();
        }, 100);
      });

      ($('#timeBoundStartTime') as any).timepicker().on('changeTime.timepicker', (e) => {
        // bootstrap-timepicker syncs via a native 'change' event too - same fix as above.
        this.timeBoundStartTime = ($('#timeBoundStartTime') as any).val();
        this._validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound();
        setTimeout(() => {
          // trigger a reminder change to check if remind after days is in bound
          this.reminderChanged();
        }, 100);
      });

      ($('#timeBoundEndTime') as any).timepicker().on('changeTime.timepicker', (e) => {
        this.timeBoundEndTime = ($('#timeBoundEndTime') as any).val();
        this._validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound();
        setTimeout(() => {
          // trigger a reminder change to check if remind after days is in bound
          this.reminderChanged();
        }, 100);
      });

    });
  }

  _initializeDateAndTimePickersForSlotWise() {
    $(document).ready(() => {
      let currentDateTimeStringInSelectedTimeZone = momentTImezone().tz(this.assessmentData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
      let currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
      let momentOfDefaultEndDateTime = moment(currentDate).add(this.accessTimePreferences.timeToComplete, 'd');

      ($('#slotWiseStartDate') as any).datepicker({
        format: "M d, yyyy",
        startDate: currentDate,
        weekStart: 1,
        autoclose: true
      });
      // set current date as default value
      ($("#slotWiseStartDate") as any).datepicker("setDate", currentDate);
      ($("#slotWiseStartDate") as any).datepicker("update", this.fourDotFiveDateFormatPipe.transform(currentDate));
      // these widgets sync via a native 'change' event, which Angular's ngModel does
      // not listen for on text inputs - set the model explicitly for the initial value too.
      this.slotWiseStartDate = ($("#slotWiseStartDate") as any).val();

      ($('#slotWiseEndDate') as any).datepicker({
        format: "M d, yyyy",
        startDate: currentDate,
        weekStart: 1,
        autoclose: true
      });

      ($("#slotWiseEndDate") as any).datepicker("setDate", momentOfDefaultEndDateTime.toDate());
      ($("#slotWiseEndDate") as any).datepicker("update", this.fourDotFiveDateFormatPipe.transform(momentOfDefaultEndDateTime.toDate()));
      this.slotWiseEndDate = ($("#slotWiseEndDate") as any).val();

      ($('#slotWiseStartTime') as any).timepicker({
        minuteStep: 5,
        showSeconds: false,
        showMeridian: true,
        disableFocus: true,
        defaultTime: '09:00 AM'
      });
      this.slotWiseStartTime = '09:00 AM';

      ($('#slotWiseEndTime') as any).timepicker({
        minuteStep: 5,
        showSeconds: false,
        showMeridian: true,
        disableFocus: true,
        defaultTime: '12:00 PM'
      });
      this.slotWiseEndTime = '12:00 PM';

      ($('#slotWiseStartDate') as any).datepicker().on('changeDate', (e) => {
        // bootstrap-datepicker/timepicker sync via a native 'change' event, which
        // Angular's ngModel does not listen for on text inputs (only 'input') -
        // read the picker's value directly so the model isn't left stale.
        this.slotWiseStartDate = ($('#slotWiseStartDate') as any).val();
        this._validateAndCorrectStartDateAndEndDateForSlotWise();
        setTimeout(() => {
          // trigger a reminder change to check if remind after days is in bound
          this.reminderChanged();
        }, 100);
      });

      ($('#slotWiseEndDate') as any).datepicker().on('changeDate', (e) => {
        this.slotWiseEndDate = ($('#slotWiseEndDate') as any).val();
        this._validateAndCorrectStartDateAndEndDateForSlotWise();
        setTimeout(() => {
          // trigger a reminder change to check if remind after days is in bound
          this.reminderChanged();
        }, 100);
      });

      ($('#slotWiseStartTime') as any).timepicker().on('changeTime.timepicker', (e) => {
        this.slotWiseStartTime = ($('#slotWiseStartTime') as any).val();
        this._validateAndCorrectStartTimeAndEndTimeForSlotWise();
      });

      ($('#slotWiseEndTime') as any).timepicker().on('changeTime.timepicker', (e) => {
        this.slotWiseEndTime = ($('#slotWiseEndTime') as any).val();
        this._validateAndCorrectStartTimeAndEndTimeForSlotWise();
      });

    });
  }

  _getTimeStringInAMPMFormat(date) {
    return moment(date).format("hh:mm A");
  }

  _validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound() {
    // setTime/setDate below fire the picker's own change event synchronously, which is wired
    // back to this same method - without a reentrancy guard that can recurse until the call
    // stack overflows (seen as "Maximum call stack size exceeded" in String.replace, which the
    // datepicker/timepicker plugins use internally to format the value on every set call).
    if (this._validatingTimeBound) {
      return;
    }
    this._validatingTimeBound = true;
    try {
      this._doValidateAndCorrectStartDateTimeAndEndDateTimeForTimeBound();
    } finally {
      this._validatingTimeBound = false;
    }
  }

  _doValidateAndCorrectStartDateTimeAndEndDateTimeForTimeBound() {
    let currentDateTimeStringInSelectedTimeZone = momentTImezone().tz(this.assessmentData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
    let momentOfCurrentDateTime = moment(currentDateTimeStringInSelectedTimeZone);
    let currentStartDateTime = new Date(this.timeBoundStartDate + ' ' + this.timeBoundStartTime);
    let momentOfCurrentStartDateTime = moment(currentStartDateTime);
    let currentEndDateTime = new Date(this.timeBoundEndDate + ' ' + this.timeBoundEndTime);
    // if the start date is same as the current date
    let startDateAndCurrentDateAreSameFlag = momentOfCurrentStartDateTime.isSame(momentOfCurrentDateTime, 'day');
    // if the start hours are less than current hours
    let startHoursLessThanCurrentHoursFlag = momentOfCurrentStartDateTime.isBefore(momentOfCurrentDateTime, 'hour');
    let remainderWithClosestQuarter = momentOfCurrentDateTime.minute() % 15;
    let currentDateTimeFlooredToClosetQuarter = momentOfCurrentDateTime.subtract(remainderWithClosestQuarter, 'm').toDate();
    // if the hours are equal but minutes are less than current date time floored to closest quarter minutes.
    let hoursEqualButStartMinutesLessThanCurrentMinutesFlag = (momentOfCurrentStartDateTime.isSame(momentOfCurrentDateTime, 'hour') && momentOfCurrentStartDateTime.isBefore(currentDateTimeFlooredToClosetQuarter, 'minute'));
    if (startDateAndCurrentDateAreSameFlag && (startHoursLessThanCurrentHoursFlag || hoursEqualButStartMinutesLessThanCurrentMinutesFlag)) {
      ($("#timeBoundStartTime") as any).timepicker("setTime", this._getTimeStringInAMPMFormat(currentDateTimeFlooredToClosetQuarter));
    } else if (currentStartDateTime >= currentEndDateTime) {
      // after the change to 'start time', check if the existing 'end time' component keeps 'end date time' as greater than 'start date time'
      // if not, make the 'end date time' as 'time to complete' days greater than currentStartDateTime
      let defaultEndDateTime = moment(currentStartDateTime).add(this.accessTimePreferences.timeToComplete, 'd').toDate();
      ($("#timeBoundEndDate") as any).datepicker("setDate", defaultEndDateTime);
      ($("#timeBoundEndDate") as any).datepicker("update", this.fourDotFiveDateFormatPipe.transform(defaultEndDateTime));
      this.timeBoundEndDate = ($("#timeBoundEndDate") as any).val();
      ($('#timeBoundEndTime') as any).timepicker("setTime", '11:59 PM');
    }
    // set start date of end date calendar to be current start date
    ($("#timeBoundEndDate") as any).datepicker("setStartDate", currentStartDateTime);
  }

  _validateAndCorrectStartDateAndEndDateForSlotWise() {
    // see _validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound for why this guard exists.
    if (this._validatingSlotWiseDate) {
      return;
    }
    this._validatingSlotWiseDate = true;
    try {
      this._doValidateAndCorrectStartDateAndEndDateForSlotWise();
    } finally {
      this._validatingSlotWiseDate = false;
    }
  }

  _doValidateAndCorrectStartDateAndEndDateForSlotWise() {
    let momentOfCurrentStartDate = moment(new Date(this.slotWiseStartDate));
    let momentOfCurrentEndDate = moment(new Date(this.slotWiseEndDate));
    if (momentOfCurrentEndDate.isBefore(momentOfCurrentStartDate, 'day')) {
      // make the 'end date' as 'time to complete' days greater than 'start date'
      let defaultEndDate = momentOfCurrentStartDate.add(this.accessTimePreferences.timeToComplete, 'd').toDate();
      ($("#slotWiseEndDate") as any).datepicker("setDate", defaultEndDate);
      ($("#slotWiseEndDate") as any).datepicker("update", this.fourDotFiveDateFormatPipe.transform(defaultEndDate));
      this.slotWiseEndDate = ($("#slotWiseEndDate") as any).val();
    }
    // set start date of end date calendar to be current start date
    ($("#slotWiseEndDate") as any).datepicker("setStartDate", momentOfCurrentStartDate.toDate());
  }

  _validateAndCorrectStartTimeAndEndTimeForSlotWise() {
    // see _validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound for why this guard exists.
    if (this._validatingSlotWiseTime) {
      return;
    }
    this._validatingSlotWiseTime = true;
    try {
      this._doValidateAndCorrectStartTimeAndEndTimeForSlotWise();
    } finally {
      this._validatingSlotWiseTime = false;
    }
  }

  _doValidateAndCorrectStartTimeAndEndTimeForSlotWise() {
    // use start date for the date part. Otherwise we can't parse date.
    let momentOfCurrentStartTime = moment(new Date(this.slotWiseStartDate + " " + this.slotWiseStartTime));
    let momentOfCurrentEndTime = moment(new Date(this.slotWiseStartDate + " " + this.slotWiseEndTime));
    if (momentOfCurrentEndTime.isBefore(momentOfCurrentStartTime)) {
      // make the 'end time' as 1 hour greater than 'start time'
      let defaultEndTime = momentOfCurrentStartTime.add(1, 'h').toDate();
      ($('#slotWiseEndTime') as any).timepicker("setTime", this._getTimeStringInAMPMFormat(defaultEndTime));
    }
  }

  onInternalNoteChanged() {
    this.assessmentData.externalNote = this.assessmentData.notes;
  }

  onExternalNoteChange(event) {
    this.assessmentData.externalNote = event.externalNote;
  }

  onCopyNoteChange(event) {
    this.copyNote = event.copyNote;
  }

  receiveFormalizedComment(event) {
    this.assessmentData.notes = event;
    this.onInternalNoteChanged();
  }

  onVoiceTranscript(transcript) {
    if (this.assessmentData.notes) {
      this.assessmentData.notes += ' ' + transcript;
    } else {
      this.assessmentData.notes = transcript;
    }
    this.onInternalNoteChanged();
  }
  reminderEnabledOrDisabled() {
    if (!this.isReminderEnabled) {
      this.assessmentData.reminder = 0;
      this.reminderErrorFlag = false;
    } else {
      this.assessmentData.reminder = this.defaultReminderInterval;
      this.reminderChanged();
    }
  }

}
